<template>
  <v-container :class="containerClass" fluid>
    <!-- Header Section -->
    <v-row>
      <v-col cols="12">
        <v-sheet>
          <v-container fluid>
            <v-row align="center">
              <v-col cols="12" md="auto">
                <h2>Class Schedules</h2>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="6" md="auto">
                <v-btn
                  color="primary"
                  :small="$vuetify.breakpoint.mobile"
                  :block="$vuetify.breakpoint.mobile"
                  :href="$route('classroom-schedules.create')"
                >
                  <v-icon :small="$vuetify.breakpoint.mobile" left
                    >mdi-plus</v-icon
                  >Tambah
                </v-btn>
              </v-col>
              <v-col cols="6" md="auto">
                <v-btn
                  :small="$vuetify.breakpoint.mobile"
                  :block="$vuetify.breakpoint.mobile"
                  @click="showFilters = !showFilters"
                >
                  <v-icon :small="$vuetify.breakpoint.mobile" left
                    >mdi-filter </v-icon
                  >{{ showFilters ? 'Hide' : 'Show' }} Filter
                </v-btn>
              </v-col>
              <v-col cols="12" md="auto">
                <v-btn-toggle
                  v-model="tab"
                  :block="$vuetify.breakpoint.mobile"
                  @change="getListData"
                >
                  <v-btn
                    v-for="(t, i) in tabs"
                    :key="i"
                    :small="$vuetify.breakpoint.mobile"
                  >
                    <v-icon left :small="$vuetify.breakpoint.mobile">{{
                      t.icon
                    }}</v-icon>
                    {{ t.text }}
                  </v-btn>
                </v-btn-toggle>
              </v-col>
            </v-row>
          </v-container>
        </v-sheet>
        <v-divider></v-divider>
        <v-expand-transition>
          <v-sheet v-show="showFilters" color="grey lighten-5">
            <v-container fluid class="pa-4">
              <v-row>
                <v-col v-if="!isTeacherAccount" md="2" cols="12">
                  <div class="label mb-2">Teacher</div>
                  <v-autocomplete
                    v-model="filters.teacher_id"
                    :items="teachers"
                    item-text="name"
                    item-value="id"
                    :loading="isTeacherListLoading"
                    outlined
                    solo
                    flat
                    background-color="white"
                    label="Teacher"
                    hide-details
                    dense
                    clearable
                    @change="getListData"
                    @click:clear="getListData"
                  />
                </v-col>
                <v-col v-if="!isStudentAccount" md="2" cols="12">
                  <div class="label mb-2">Student</div>
                  <v-autocomplete
                    v-model="filters.student_id"
                    :items="students"
                    item-text="name"
                    item-value="id"
                    :loading="isStudentListLoading"
                    :search-input.sync="searchInputStudent"
                    outlined
                    solo
                    flat
                    background-color="white"
                    label="Student"
                    hide-details
                    dense
                    clearable
                    cache-items
                    @change="getListData"
                    @click:clear="getListData"
                  />
                </v-col>
                <v-col md="2" cols="12">
                  <div class="label mb-2">Classroom</div>
                  <v-autocomplete
                    v-model="filters.classroom_id"
                    :items="classrooms"
                    item-text="name"
                    item-value="id"
                    :loading="isClassroomListLoading"
                    outlined
                    solo
                    flat
                    background-color="white"
                    label="Classroom"
                    hide-details
                    dense
                    clearable
                    @change="getListData"
                    @click:clear="getListData"
                  />
                </v-col>
                <v-col md="2" cols="12">
                  <div class="label mb-2">Class Status</div>
                  <v-select
                    v-model="filters.class_status"
                    :items="classStatusOptions"
                    outlined
                    solo
                    flat
                    background-color="white"
                    label="Status"
                    hide-details
                    dense
                    clearable
                    @change="changeClassStatus"
                    @click:clear="changeClassStatus"
                  />
                </v-col>
                <v-col md="2" cols="12">
                  <div class="label mb-2">Class Date</div>
                  <date-picker
                    v-model="filters.class_date"
                    value-type="format"
                    type="date"
                    range
                    class="mx-datepicker--dense"
                    confirm
                    @confirm="getListData"
                    @clear="getListData"
                  ></date-picker>
                </v-col>
                <v-col md="2" cols="12">
                  <div class="label mb-2">Status</div>
                  <v-select
                    v-model="filters.status"
                    :items="statusOptions"
                    outlined
                    solo
                    flat
                    background-color="white"
                    label="Status"
                    hide-details
                    dense
                    clearable
                    @change="getListData"
                    @click:clear="getListData"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-row>
                    <v-col md="4" cols="12">
                      <div class="label mb-2">Term</div>
                      <v-select
                        v-model="filters.term"
                        :items="terms"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Term"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="4" cols="12">
                      <div class="label mb-2">Month</div>
                      <v-select
                        v-model="filters.month"
                        :items="months"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Month"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="4" cols="12">
                      <div class="label mb-2">Session</div>
                      <v-select
                        v-model="filters.session"
                        :items="sessions"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Session"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
            <v-divider></v-divider>
          </v-sheet>
        </v-expand-transition>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-slide-x-transition>
          <v-data-table
            v-show="tab === tabView.list"
            :headers="headers"
            :items="items"
            :loading="isLoading"
            :options.sync="options"
            :server-items-length="
              itemList.meta ? itemList.meta.total : items.length
            "
            :footer-props="defaultDataTableFooterProps"
            item-key="id"
          >
            <template #[`item.class_date`]="{ item }">
              {{ formatDate(item.class_date, 'DD MMM YYYY') }}
            </template>
            <template #[`item.class_name`]="{ item }">
              {{ item.classroom.name }}
            </template>
            <template #[`item.teacher`]="{ item }">
              {{ item.classroom.teacher.user.name }}
              {{ item.classroom.teacher.is_native_speaker ? '(Native)' : '' }}
            </template>
            <template #[`item.class_type`]="{ item }">
              {{ classroomTypeProps(item.classroom.class_type, 'text') }}
            </template>
            <template #[`item.class_time`]="{ item }">
              {{ formatTime(item.start_time) }} -
              {{ formatTime(item.end_time) }} <br />
              <div class="text-caption">
                {{ timeDiffText(item.start_time, item.end_time) }}
              </div>
            </template>
            <template #[`item.lessons`]="{ item }">
              <ol class="my-2">
                <li v-for="(lesson, i) in item.lessons" :key="i">
                  {{ bilingualText(lesson, 'name', 'name_cn') }}
                </li>
              </ol>
            </template>
            <template #[`item.status`]="{ item }">
              <v-chip :color="getStatusColor(item)" small dark>
                <strong>{{ getStatusText(item) }}</strong>
              </v-chip>
            </template>
            <template #[`item.action`]="{ item }">
              <div class="text-right">
                <v-btn
                  v-if="isLessonsDownloadable(item)"
                  small
                  color="success"
                  class="ma-1"
                  :icon="$vuetify.breakpoint.mobile"
                  :href="
                    $route('classroom-schedules.download-lessons', item.id)
                  "
                  target="_blank"
                >
                  <v-icon small>mdi-cloud-download</v-icon>
                  <span v-if="!$vuetify.breakpoint.mobile">
                    &nbsp;Download Lessons
                  </span>
                </v-btn>
                <v-btn
                  small
                  color="secondary"
                  class="ma-1"
                  :icon="$vuetify.breakpoint.mobile"
                  :href="$route('classroom-schedules.detail', item.id)"
                >
                  <v-icon small>mdi-eye</v-icon>
                  <span v-if="!$vuetify.breakpoint.mobile">&nbsp;View</span>
                </v-btn>
                <v-btn
                  v-if="hasPermission('classroom-schedules.update')"
                  small
                  color="warning"
                  class="ma-1"
                  :icon="$vuetify.breakpoint.mobile"
                  :href="$route('classroom-schedules.update', item.id)"
                >
                  <v-icon small>mdi-pencil</v-icon>
                  <span v-if="!$vuetify.breakpoint.mobile">&nbsp;Edit</span>
                </v-btn>
                <v-btn
                  v-if="hasPermission('classroom-schedules.delete')"
                  small
                  color="error"
                  class="ma-1"
                  :icon="$vuetify.breakpoint.mobile"
                  @click="showDeleteDialog(item)"
                >
                  <v-icon small>mdi-delete-forever</v-icon>
                  <span v-if="!$vuetify.breakpoint.mobile">&nbsp;Delete</span>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-slide-x-transition>
        <v-slide-x-transition>
          <calendar-view
            v-show="tab === tabView.calendar"
            :schedules="items"
            @click:event="showEditDialog"
          ></calendar-view>
        </v-slide-x-transition>
      </v-col>
    </v-row>
    <classroom-schedule-delete-dialog
      v-if="deleteDialog.show"
      v-model="deleteDialog.show"
      :schedule="deleteDialog.item"
      @delete="getListData"
    >
    </classroom-schedule-delete-dialog>
    <edit-schedule-dialog
      v-if="editDialog.show"
      v-model="editDialog.show"
      :item.sync="editDialog.item"
      submit-api
      @submit="onSubmitEdit"
    ></edit-schedule-dialog>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import constant from '@/constant'
import colorpalette from '@/colorpalette'
import CalendarView from '@components/ClassroomSchedule/CalendarView'
import ClassroomScheduleDeleteDialog from '@components/ClassroomSchedule/DeleteDialog'
import EditScheduleDialog from '@components/ClassroomSchedule/EditDialog'
import { ListParams } from '@/models'
import utils from '@/utils'

const TAB_LIST_VIEW = 0
const TAB_CALENDAR_VIEW = 1

const firstWeekOfMonth = moment.range(
  moment().startOf('month').startOf('isoWeek'),
  moment().startOf('month').endOf('isoWeek')
)

const DEFAULT_LIST_VIEW_CLASS_DATE_FILTER = [
  moment().within(firstWeekOfMonth)
    ? moment().subtract(1, 'weeks').format()
    : moment().startOf('month'),
  moment().endOf('month').format(),
]
const DEFAULT_CALENDAR_VIEW_CLASS_DATE_FILTER = [
  moment().subtract(1, 'months').startOf('month').format(),
  moment().add(1, 'months').endOf('month').format(),
]

export default {
  name: 'ClassroomSchedule',
  components: {
    CalendarView,
    ClassroomScheduleDeleteDialog,
    EditScheduleDialog,
  },
  layout: LayoutDashboard,
  data() {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['class_date'],
        sortDesc: [false],
      },
      showFilters: true,
      filters: {
        classroom_id: null,
        teacher_id: null,
        class_status: null,
        class_type: null,
        student_id: null,
        created_at: [],
        updated_at: [],
        class_date: [],
        term: null,
        month: null,
        session: null,
        status: null,
      },
      deleteDialog: {
        show: false,
        item: null,
      },
      tab: 0,
      tabs: [
        {
          text: 'List View',
          icon: 'mdi-view-list',
          view: 'list',
        },
        {
          text: 'Calendar View',
          icon: 'mdi-calendar-month',
          view: 'calendar',
        },
      ],
      tabView: {
        list: TAB_LIST_VIEW,
        calendar: TAB_CALENDAR_VIEW,
      },
      calendarWeekdays: [1, 2, 3, 4, 5, 6, 0], // Mon - Sun
      calendarTypes: ['month', 'week', 'day'],
      calendarType: 'month',
      currentDate: moment().format('YYYY-MM-DD'),
      calendarEventMenu: false,
      calendarEventElement: null,
      selectedCalendarEvent: {
        id: 0,
        classroom: {},
      },
      classDateMenu: false,
      searchInputStudent: null,
      editDialog: {
        show: false,
        item: null,
        index: -1,
      },
      items: [],
    }
  },
  computed: {
    ...mapGetters({
      itemList: 'classroomSchedule/list',
      isItemListLoading: 'classroomSchedule/isListLoading',
      itemDetail: 'classroomSchedule/detail',
      teacherList: 'teacher/list',
      isTeacherListLoading: 'teacher/isListLoading',
      classroomList: 'classroom/list',
      isClassroomListLoading: 'classroom/isListLoading',
      studentList: 'student/searchList',
      isStudentListLoading: 'student/isSearchListLoading',
      authUser: 'authUser',
      isTeacherAccount: 'isTeacherAccount',
      isStudentAccount: 'isStudentAccount',
      listParams: 'classroomSchedule/listParams',
      studyProgressList: 'studyProgress/list',
      isStudyProgressListLoading: 'studyProgress/isListLoading',
    }),
    isLoading() {
      return this.isItemListLoading || this.isStudyProgressListLoading
    },
    classTypeOptions() {
      return constant.classroomTypeOptions
    },
    classStatusOptions() {
      return constant.classroomStatusOptions
    },
    statusOptions() {
      return ['All', 'Completed', 'Pending Report']
    },
    teachers() {
      return this.teacherList.data
    },
    classrooms() {
      return this.classroomList.data
    },
    students() {
      return this.studentList.data
    },
    calendarEvents() {
      return this.itemList.data.map((item) => ({
        id: item.id,
        name: item.classroom.name,
        start: moment(`${item.class_date}T${item.start_time}`).toDate(),
        end: moment(`${item.class_date}T${item.end_time}`).toDate(),
        timed: true,
        color: colorpalette[item.classroom_id % 99],
        classroom: item.classroom,
        classroom_id: item.classroom_id,
        class_date: item.class_date,
        start_time: item.start_time,
        end_time: item.end_time,
      }))
    },
    headers() {
      return [
        { text: 'Class Date', value: 'class_date' },
        { text: 'Term', value: 'term' },
        { text: 'Month', value: 'month' },
        { text: 'Session', value: 'session' },
        { text: 'Class Name', value: 'class_name', sortable: false },
        ...(this.isTeacherAccount === false
          ? [{ text: 'Teacher', value: 'teacher', sortable: false }]
          : []),
        { text: 'Class Type', value: 'class_type', sortable: false },
        { text: 'Class Time', value: 'class_time', sortable: false },
        { text: 'Lessons', value: 'lessons', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Action', value: 'action', sortable: false, align: 'center' },
      ]
    },
    studyProgresses() {
      return this.studyProgressList.data
    },
    groupedStudyProgressLessons() {
      return this.studyProgresses.reduce((carry, sp) => {
        if (!carry[sp.classroom_schedule_id]) {
          carry[sp.classroom_schedule_id] = []
        }
        if (sp.details.length > 0) {
          carry[sp.classroom_schedule_id] = sp.details.map((detail) => ({
            id: detail.lesson_id,
            name: detail.lesson_name,
            name_cn: detail.lesson_name_cn,
            lesson_category_id: detail.lesson_category_id,
          }))
        }
        return carry
      }, {})
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getListData()
      },
    },
    searchInputStudent(val) {
      if (val) {
        this.debouncedSearchStudentList()
      }
    },
  },
  created() {
    this.init()
    this.debouncedSearchStudentList = _.debounce(this.searchStudentList, 500)
  },
  methods: {
    ...mapActions({
      getItemList: 'classroomSchedule/getList',
      getTeacherList: 'teacher/getList',
      getClassroomList: 'classroom/getList',
      getStudentList: 'student/search',
      getItemDetail: 'classroomSchedule/getDetail',
      handleError: 'handleError',
      getStudyProgressList: 'studyProgress/getList',
    }),
    ...mapMutations({
      setListParams: 'classroomSchedule/setListParams',
    }),
    init() {
      const params = route().params
      if (params.view) {
        const tabIndex = this.tabs.findIndex((e) => e.view === params.view)
        if (tabIndex != -1) {
          this.tab = tabIndex
        }
      }
      if (this.isTeacherAccount) {
        this.filters.teacher_id = this.authUser.account_id
        this.filters.class_status = 'ACTIVE'
      } else {
        this.getTeacherList()
      }
      if (this.isStudentAccount) {
        this.filters.student_id = this.authUser.account_id
        this.filters.class_status = 'ACTIVE'
      }
      if (this.tab === TAB_LIST_VIEW) {
        this.filters.class_date = DEFAULT_LIST_VIEW_CLASS_DATE_FILTER
      } else if (this.tab === TAB_CALENDAR_VIEW) {
        this.filters.class_date = DEFAULT_CALENDAR_VIEW_CLASS_DATE_FILTER
      }

      if (this.listParams) {
        _.merge(this.filters, this.listParams.filters)
        if (this.tab === TAB_LIST_VIEW) {
          _.merge(this.options, this.listParams.options)
        }
      }
      this.getClassroomListData()
    },
    async changeClassStatus() {
      await Promise.all([this.getClassroomListData(), this.getListData()])
    },
    async getClassroomListData() {
      await this.getClassroomList({
        status: this.filters.class_status ?? undefined,
        teacher_id: this.filters.teacher_id ?? undefined,
        student_id: this.filters.student_id,
      })
    },
    async getListData() {
      const filters = _.cloneDeep(this.filters)
      filters.status = undefined
      switch (this.filters.status) {
        case 'Completed':
          filters.is_completed = 1
          break
        case 'Pending Report':
          filters.is_completed = 0
          break
        default:
          filters.is_completed = undefined
          break
      }
      if (this.tab === TAB_LIST_VIEW) {
        const listParams = new ListParams(filters, this.options)
        await this.getItemList(utils.toServerSideQuery(listParams))
        this.setListParams(listParams)
      } else if (this.tab === TAB_CALENDAR_VIEW) {
        await this.getItemList({
          ...filters,
          sort: ['class_date,asc'],
        })
      }
      await this.getStudyProgressList({
        classroom_id: [
          ...new Set(this.itemList.data.map((e) => e.classroom_id)),
        ],
      })
      this.items = this.itemList.data.map((e) => {
        const item = _.cloneDeep(e)
        if (item.lessons.length === 0) {
          item.lessons = this.groupedStudyProgressLessons[item.id] ?? []
        }
        return item
      })
    },
    showDeleteDialog(item) {
      this.deleteDialog.item = item
      this.deleteDialog.show = true
    },
    showEditDialog(item) {
      const schedule = this.itemList.data.find((e) => e.id === item.id)
      if (schedule) {
        this.editDialog.item = _.cloneDeep(schedule)
        this.editDialog.show = true
      }
    },
    async onSubmitEdit() {
      await this.getListData()
      this.editDialog.index = -1
      this.editDialog.item = null
      this.editDialog.show = false
    },
    isLessonsDownloadable(schedule) {
      return (
        schedule.lessons &&
        schedule.lessons.length > 0 &&
        schedule.lessons.some((e) => e.attachment_file_url)
      )
    },
    getStatusColor(item) {
      const today = moment()
      const dt = moment(item.class_date)
      if (item.is_completed) {
        return 'success'
      } else if (dt.isSameOrBefore(today)) {
        return 'error'
      } else {
        return 'grey'
      }
    },
    getStatusText(item) {
      const today = moment()
      const dt = moment(item.class_date)
      if (item.is_completed) {
        return 'Completed'
      } else if (dt.isSameOrBefore(today)) {
        return 'Pending Report'
      } else {
        return 'Upcoming'
      }
    },
    searchStudentList() {
      this.getStudentList({ search: this.searchInputStudent })
    },
  },
}
</script>
